import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { usePageTitle } from '../../../Hooks/usePageTitle';
import { getBlockedUsers } from '../../../Services/User/BlockedUsers';
import { useGoogleTranslate } from '../../../Hooks/useGoogleTranslate';
import heartDecor from '../../../assets/images/coin-store-figma/decor-heart.svg';
import './BlockedUsers.css';

const BlockedUsers = () => {
  const pageTitle = useGoogleTranslate('Blocked Users');
  const loadingLabel = useGoogleTranslate('Loading blocked users...');
  const noBlockedUsers = useGoogleTranslate('No blocked users');
  const snoLabel = useGoogleTranslate('S.No.');
  const usernameLabel = useGoogleTranslate('Username');
  const statusLabel = useGoogleTranslate('Status');
  const wantsToLabel = useGoogleTranslate('Wants To');
  const unblockLabel = useGoogleTranslate('Unblock');

  usePageTitle(pageTitle);

  const { data: user, isLoading } = useQuery({
    queryKey: ['blocked-users'],
    queryFn: getBlockedUsers,
  });

  const renderLayout = (content) => (
    <section className="blocked-users-figma-page">
      <img src={heartDecor} alt="" className="blocked-users-figma-heart" aria-hidden="true" />
      <div className="blocked-users-figma-hero">
        <Container>
          <h1 className="blocked-users-figma-title">{pageTitle}</h1>
        </Container>
      </div>
      <div className="blocked-users-figma-main py-sm-5 py-4">
        <Container className="blocked-users-figma-container">{content}</Container>
      </div>
    </section>
  );

  if (isLoading) {
    return renderLayout(
      <Row>
        <Col xs={12} className="text-center">
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
          <p className="mt-3">{loadingLabel}</p>
        </Col>
      </Row>
    );
  }

  if (!user?.data || user.data.length === 0) {
    return renderLayout(
      <Row>
        <Col xs={12} className="text-center">
          <p className="mt-3">{noBlockedUsers}</p>
        </Col>
      </Row>
    );
  }

  return renderLayout(
    <Row>
      <Col xs={12} className="my-3">
        <div className="blocked-users-figma-card table-responsive">
          <table className="table blocked-users-figma-table text-center mb-0">
            <thead>
              <tr>
                <th>{snoLabel}</th>
                <th>{usernameLabel}</th>
                <th>{statusLabel}</th>
                <th>{wantsToLabel}</th>
              </tr>
            </thead>
            <tbody>
              {user?.data?.map((user, index) => (
                <tr key={user.id}>
                  <td>{index < 9 ? `0${index + 1}` : index + 1}</td>
                  <td>{user.username}</td>
                  <td>
                    <span className={`chip ${user.status === 'blocked' ? 'red-text' : 'green-text'}`}>
                      {user.status}
                    </span>
                  </td>
                  <td>
                    <button className="blocked-users-unblock-btn transparent-btn">{unblockLabel}</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Col>
    </Row>
  );
};

export default BlockedUsers;
